import script from "./ComplitedTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./ComplitedTasks.vue?vue&type=script&setup=true&lang=js"

import "./ComplitedTasks.vue?vue&type=style&index=0&id=18c799a8&lang=scss"

const __exports__ = script;

export default __exports__